import Protected from "./ProtectedContainer";

export default Protected;
